<pg-solutions>
  <section>
    <header>
      <h1>Soluções</h1>
      <p>Com mais de 10 instituições financeiras parceiras, a <b>VLGI Corporate</b> está pronta para entregar as melhores oportunidades para o seu negócio.</p>
    </header>

    <section id="bank">
      <div class="ornaments">
        <img class="ornaments-img" src={mask1} alt=""  data-aos-anchor-placement="center-bottom">
        <img class="ornaments-bg" src={bg1} alt="" data-aos-anchor-placement="center-bottom">
      </div>
      <div class="container">
        <header>
          <h2>Investment Banking</h2>
          <p>Soluções financeiras sofisticadas e personalizadas para cada cliente.</p>
        </header>
        <div class="content">
          <span>Operações:</span>
          <ul>
            <li>DCM (Debt Capital Markets - Mercado de Dívida) <i class="icon-down-open"></i> </li>
            <li>ECM (Equity Capital Markets - Mercado de Ações) <i class="icon-down-open"></i> </li>
            <li>Fusões e Aquisições (M&amp;A) <i class="icon-down-open"></i> </li>
            <li>Notas Promissórias </li>
            <li>Project Finance <i class="icon-down-open"></i> </li>
          </ul>
        </div>
      </div>
    </section>

    <section id="credit">
      <div class="ornaments">
        <img class="ornaments-img" src={hands} alt="" data-aos-anchor-placement="center-bottom">
        <img class="ornaments-bg" src={bg2} alt="" data-aos-anchor-placement="center-bottom">
      </div>
      <div class="container">
        <header>
          <h2>Soluções de Crédito</h2>
          <p>As melhores soluções de crédito para você e sua empresa.</p>
        </header>
        <div class="content">
          <span>Operações:</span>
          <ul>
            <li>Antecipação de Recebíveis </li>
            <li>Antecipação a Fornecedores </li>
            <li>Capital de Giro </li>
            <li>CDC </li>
            <li>Leasing </li>
            <li>Fiança Bancária </li>
            <li>Crédito Consignado </li>
            <li>Home Equity <i class="icon-down-open"></i> </li>
            <li>Crédito Rural</li>
            <li>Crédito Imobiliário</li>
          </ul>
        </div>
      </div>
    </section>

    <section id="others">
      <div class="ornaments">
        <img src={mask2} alt="" data-aos-anchor-placement="center-bottom">
      </div>
      <div class="container">
        <header>
          <h2>Outros Negócios</h2>
          <p>Conheça outros tipos de soluções que a VLGI Corporate oferece para otimizar o seu negócio.</p>
        </header>
        <div class="content">
          <span>Operações:</span>
          <ul>
            <li>Câmbio <i class="icon-down-open"></i> </li>
            <li>Offshore <i class="icon-down-open"></i> </li>
            <li>Derivativos <i class="icon-down-open"></i> </li>
          </ul>
        </div>
      </div>
    </section>

  </section>

  <script>
    import './pg-solutions.scss'

    import hands from '../media/solutions-bg/section-2.png'
    import mask1 from '../media/solutions-bg/section-1.png'
    import mask2 from '../media/solutions-bg/section-3.png'
    import bg1 from '../media/solutions-1.svg'
    import bg2 from '../media/solutions-2.svg'
    import bg3 from '../media/fundo_outros_negocios.svg'

    import aos from 'aos'
    import 'aos/dist/aos.css'

    export default {
      hands, mask1, mask2, bg1, bg2, bg3,
      onMounted() {
        aos.init({
          anchorPlacement: 'center-bottom'
        })
      }
    }
  </script>
</pg-solutions>
